import { Link } from 'react-router-dom';

export interface DramaCardData {
  id: string;
  title: string;
  year: number;
  region: string;
  rating: number;
  genres: string[];
  summary: string;
  poster: string;
}

interface DramaCardProps {
  drama: DramaCardData;
  index?: number;
}

export default function DramaCard({ drama, index = 0 }: DramaCardProps) {
  return (
    <Link
      to={`/detail/${drama.id}`}
      className="group block cursor-pointer animate-fade-up"
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
    >
      <article className="h-full overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-300 hover:border-accent-300">
        <div className="relative w-full aspect-[5/7] overflow-hidden bg-primary-900">
          <img
            src={drama.poster}
            alt={`${drama.title} 剧集封面`}
            title={`${drama.title} 韩国伦理剧`}
            className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-primary-950/70 via-transparent to-transparent opacity-80" />
          <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-semibold text-background-50">
            <i className="ri-star-fill text-[11px]" />
            {drama.rating.toFixed(1)}
          </span>
          <div className="absolute bottom-3 left-3 right-3 flex flex-wrap gap-1">
            {drama.genres.slice(0, 2).map((g) => (
              <span
                key={g}
                className="rounded-md bg-background-50/85 px-2 py-0.5 text-[11px] font-medium text-primary-800"
              >
                {g}
              </span>
            ))}
          </div>
        </div>
        <div className="p-4">
          <h3 className="mb-1 truncate font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
            {drama.title}
          </h3>
          <p className="mb-2 text-xs text-foreground-500">
            {drama.year} · {drama.region}
          </p>
          <p className="line-clamp-2 text-sm leading-relaxed text-foreground-700">{drama.summary}</p>
        </div>
      </article>
    </Link>
  );
}